import React from "react";

import {
  Pill,
  QueueList,
  QueueRow,
  QueueRowMeta,
  QueueRowSymbol,
  RowHeading,
} from "../../styles";
import { formatLastRun } from "../../utils/format";
import { labelOfStatus, toneOfStatus } from "../../utils/status";
import { SchedulerStatusListProps } from "../types";

export const SchedulerStatusList: React.FC<SchedulerStatusListProps> = ({
  schedulers,
  selectedName,
  listRef,
  onSelect,
}) => {
  const rows = schedulers.map(({ name, status, lastRunAt }) => ({
    name,
    tone: toneOfStatus(status),
    statusLabel: labelOfStatus(status),
    lastRun: formatLastRun(lastRunAt),
    isSelected: name === selectedName,
    handleClick: () => onSelect(name),
  }));

  return (
    <QueueList ref={listRef} aria-label="Schedulers">
      {rows.map(
        ({ name, tone, statusLabel, lastRun, isSelected, handleClick }) => (
          <li key={name}>
            <QueueRow
              type="button"
              $isSelected={isSelected}
              aria-pressed={isSelected}
              onClick={handleClick}
            >
              <RowHeading>
                <QueueRowSymbol>{name}</QueueRowSymbol>
                <Pill $tone={tone}>{statusLabel}</Pill>
              </RowHeading>
              <QueueRowMeta>{lastRun}</QueueRowMeta>
            </QueueRow>
          </li>
        ),
      )}
    </QueueList>
  );
};
